module.exports = __webpack_public_path__ + "img/MTABAPPTEMP.7071a80f.jpg";